// extracted by mini-css-extract-plugin
export var backdropBlur = "_lt-0";
export var contentCard = "_lt-5";
export var frame = "_lt-2";
export var image = "_lt-4";
export var imagePane = "_lt-3";
export var modal = "_lt-1";